/**
 * API Service - 处理所有后端 API 调用
 */

import type { BookingFormData, EstimateFormData } from '../types';

const API_BASE = '/api';

interface ApiResponse {
  success: boolean;
  message?: string;
  error?: string;
  confirmationSent?: boolean;
}

/**
 * 提交预约请求
 */
export async function submitBooking(data: BookingFormData): Promise<ApiResponse> {
  try {
    const response = await fetch(`${API_BASE}/booking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        formType: 'booking',
      }),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Booking submission error:', error);
    return {
      success: false,
      error: 'Network error. Please try again or call us directly.',
    };
  }
}

/**
 * 提交询价请求
 */
export async function submitEstimate(data: EstimateFormData): Promise<ApiResponse> {
  try {
    const response = await fetch(`${API_BASE}/booking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: data.name,
        email: data.email,
        phone: data.phone,
        date: data.preferredDate,
        time: '',
        guestCount: data.guestCount,
        region: data.region,
        message: `Event Type: ${data.eventType}\n${data.additionalInfo || ''}`,
        formType: 'estimate',
      }),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Estimate submission error:', error);
    return {
      success: false,
      error: 'Network error. Please try again or call us directly.',
    };
  }
}

/**
 * 获取系统设置（公开）
 */
export async function fetchSettings(): Promise<{
  success: boolean;
  settings?: {
    timeSlots: Array<{ id: string; label: string; startTime: string; endTime: string; enabled: boolean }>;
    minGuests: number;
    maxGuests: number;
    pricePerPerson: number;
    minimumOrder: number;
    socialLinks?: { instagram: string; facebook: string; tiktok: string };
    promoBanner?: { enabled: boolean; text: string; emoji: string };
    contactInfo?: { phone: string; email: string; contactPerson: string };
    galleryImages?: Array<{ id: string; url: string; caption: string; order: number }>;
  };
  error?: string;
}> {
  try {
    const response = await fetch(`${API_BASE}/settings`);
    return await response.json();
  } catch (error) {
    console.error('Fetch settings error:', error);
    return { success: false, error: 'Failed to fetch settings' };
  }
}




